// for add employee
export const RESER_GIVE_RAISE = "reset_give_raise";
export const GIVE_RAISE = "give_raise";
export const GIVE_RAISE_SUCCESS = "give_raise_success";
export const GIVE_RAISE_FAILURE = "give_raise_failure";
